/**/
const DEFAULT_COLOR = '#E0E0E0';
const COLOR_LIST = ['#94BFFF', '#3DDD9A', '#C39EFF', '#FFBE72'];

export function getColourByYear(year: number) {
  const thisYear = new Date().getFullYear();
  return COLOR_LIST[thisYear - year] || DEFAULT_COLOR;
}
